module.exports = __webpack_public_path__ + "img/email_sent.8cfa214b.svg";